import React from 'react';
import { TagShapeProps } from '../utils/common-graph.utils';

export const LaddergramEmptyCircle: React.FC<TagShapeProps> = ({
  color,
  size,
}) => {
  return (
    <g transform={`translate(${size / 2}, ${size / 2})`}>
      <circle r={size / 2} fill='transparent' stroke={color} />
    </g>
  );
};
